module.exports = __webpack_public_path__ + "static/EmilyIsAway0-e52a38256d00fcb8066817e9a0fed279.webp";